import { useRef } from 'react';
import styled, { css } from 'styled-components';

interface CheckboxProps {
    value?: boolean;
    onChange(value: boolean): void;
    label?: string;
    size?: CheckboxSize;
}

enum CheckboxSize { MEDIUM, LARGE }

export default function Checkbox({ value = false, onChange, label, size = CheckboxSize.LARGE }: CheckboxProps) {
    const state = useRef(value);
    const selfRef = useRef<HTMLDivElement>(null);

    if (typeof value === 'boolean' && state.current !== value) { state.current = !state.current; setState(); }

    function setState() {
        state.current ? selfRef.current?.classList.add('true') : selfRef.current?.classList.remove('true');
    }

    function onClick() {
        state.current = !state.current;
        onChange(state.current);
        setState();
    }

    return (
        <Wrapper size={size} ref={selfRef} {...{ onClick }} className={state.current ? 'true' : ''}>
            <div className='checkbox-container'>
                <div className='checkbox'>
                    <div className='checkbox-check'></div>
                </div>
            </div>
        </Wrapper>
    )
}

const sizes = {
    [CheckboxSize.MEDIUM]: css`
        height: 30px;

        .checkbox { width: 20px; height: 20px; border-radius: 5px ; }
        .checkbox-check { width: 20px; height: 20px; border-radius: 5px ;}
    `,
    [CheckboxSize.LARGE]: css`
        height: 40px;

        .checkbox { width: 30px; height: 30px; border-radius: 10px ; }
        .checkbox-check { width: 30px; height: 30px; border-radius: 10px ;}
    `,
}

const Wrapper = styled.div<{ size: CheckboxSize }>`
    cursor: pointer;
    display: flex;

    .checkbox-container { padding: 5px; border-radius: 50%; transition: background-color 0.2s; }

    .checkbox {
        user-select: none;
        background-color: ${props => props.theme.backgroundColor};
        transition: border 0.2s;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    &.true .checkbox .checkbox-check { transform: scale(1); opacity: 1; }

    .checkbox-check {
        transition: width 0.2s, height 0.2s, opacity 0.2s, transform 0.2s;
        background-color: ${props => props.theme.primaryColor};
        height: 20px;
        width: 20px;
        opacity: 0;
        transform: scale(0);
    }

    ${({ size }) => sizes[size]}
`